import AuthCurrentTenant from 'src/modules/auth/authCurrentTenant';
import {reconcileCurrentDivisionId} from 'src/modules/auth/currentDivisionScope';

/**
 * Lee localStorage (por tenant), reconcilia con el tenant-context y persiste de nuevo.
 */
export function syncCurrentDivisionIdFromContext(ctx: unknown): string | null {
  const raw = AuthCurrentTenant.getItem('currentDivisionId');
  const stored = raw != null && raw !== '' ? String(raw) : null;
  const next = reconcileCurrentDivisionId(ctx as any, stored);
  if (next == null) {
    AuthCurrentTenant.removeItem('currentDivisionId');
  } else {
    AuthCurrentTenant.setItem('currentDivisionId', next);
  }
  return next;
}

export function persistCurrentDivisionId(divisionId: string | null) {
  if (divisionId == null || divisionId === '') {
    AuthCurrentTenant.removeItem('currentDivisionId');
    return;
  }
  AuthCurrentTenant.setItem('currentDivisionId', divisionId);
}
